export const StockTransferData = [
  {
    id: "1",
    select: false,
    fromWarehouse: "HOOKER",
    toWarehouse: "TAÎEB",
    noOfProducts: 4,
    quantityTransferred: 14,
    refNumber: "145445",
    date: "25 Jul 2025",
    receptionist : "Montassar KLILA KERKENI",
    responsible : "Mohamed KABANI",
    received : true,
  },
  {
    id: "2",
    select: false,
    fromWarehouse: "BRAZIL",
    toWarehouse: "HOOKER",
    noOfProducts: 21,
    quantityTransferred: 10,
    refNumber: "135478",
    date: "28 Jul 2025",
    receptionist : "Montassar KLILA KERKENI",
    responsible : "Mohamed KABANI",
    received : false,
  },
  {
    id: "3",
    select: false,
    fromWarehouse: "TAÎEB",
    toWarehouse: "LA MARSA",
    noOfProducts: 15,
    quantityTransferred: 14,
    refNumber: "145124",
    date: "24 Jul 2025",
    receptionist : "Mohamed KABANI",
    responsible : "SANA Xxxxx",
    received : false,
  },
  {
    id: "4",
    select: false,
    fromWarehouse: "TAÎEB",
    toWarehouse: "HOOKER",
    noOfProducts: 14,
    quantityTransferred: 74,
    refNumber: "474541",
    date: "15 Jul 2025",
    receptionist : "SANA Xxxxx",
    responsible : "Mohamed KABANI",
    received : true,
  },
];
